module.exports = __webpack_public_path__ + "static/img/zwsp.dbfd389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zwsp.png
// module id = fkPZ
// module chunks = 1